import { useEffect, useState } from 'react';
import '../css/Nav design.css';
import upload from '../images/upload_image.png';
import TopBar from './TopBar';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import logo from '../images/logo.jpeg';
import { Oval } from "react-loader-spinner";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

function DocumentUpload() {
  const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;
  let token = loginVal ? loginVal.token : null;
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [documentList, setDocumentList] = useState([]);

  const isDocumentLimitReached = documentList.length >= 2;

  const navigation = useNavigate()
  function clickEditPage() {
    navigation('/Editprofile')
  }
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImages((prev) => [...prev, ...newImages]);
  };

  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpload = async () => {
    setIsLoading(true);
    const formData = new FormData();


    formData.append("UserId", loginVal.user_Id);

    images.forEach((img) =>
      formData.append("Files", img.file) // <-- Adjust key to match backend
    );

    try {
      const res = await axios.post(
        ApiConfig.getUrl("User/DocumentUpload"),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`

          },
        }
      );

      console.log("Upload result:", res.data);
      documentListAPICall(loginVal.user_Id);
      setIsLoading(false);
      setImages([]);
      alert("Document uploaded successfully!");
    } catch (error) {
      setIsLoading(false);
      console.error("Upload error:", error);
      alert("Upload failed!");
    }
  };
  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  useEffect(() => {
    if (loginVal?.user_Id) {
      documentListAPICall(loginVal.user_Id);
    }
  }, []);


  function documentListAPICall(user_Id) {
    setIsLoading(true);
    axios.get(

      ApiConfig.getUrl("User/getDocumentList"),
      {
        params: {
          userId: user_Id
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then(response => {
        const api = ApiResponse.fromJson(response.data);

        if (api.statusCode == 200) {
          setDocumentList(api.response);

          setIsLoading(false);
          showToast(api.message);
        }
      })
      .catch(() => {
        showToastFailed("No Report Users");
        setIsLoading(false);
      });
  }


  function documentDeleteAPICall(userId, documentId) {
    setIsLoading(true);
    //    var request = new ImagedeleteRequest();
    // request.userId =253;
    // request.imageId = 29;

    //  console.log("Response:", JSON.stringify(request));
    axios.delete(
      ApiConfig.getUrl("User/documentDelete"),
      // JSON.stringify(request),
      {
        data: {
          userId: userId,
          documentId: documentId
        },

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }

    )

      .then(response => {
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.statusCode);
        if (api.statusCode == 200) {
          setIsLoading(false);
          showToast(api.message);

          documentListAPICall(loginVal.user_Id);
        } else {
          setIsLoading(false);
        }

      })
      .catch(error => {
        setIsLoading(false);
        showToastFailed("Deleted failed!");
      });
  }

  const disableRightClick = (e) => {
    e.preventDefault();
  };




  return (
    <div className='fullview' onContextMenu={disableRightClick}>
      {isLoading && (
        <div className="loader-overlay">
          <Oval
            height={60}
            width={60}
            color="#ffffff"
            secondaryColor="#cccccc"
            strokeWidth={4}
            visible={true}
          />
        </div>
      )}
      <div className="container d-flex flex-column justify-content-center align-items-center min-vh-100">

        <div
          className="card p-4"
          style={{
            maxWidth: "480px",
            width: "100%",
            borderRadius: "16px",
            boxShadow: "0 12px 30px rgba(255, 140, 0, 0.25)",
          }}
        >
          {/* Title */}
          <h3 className="text-center fw-semibold mb-3" style={{ color: "#ff8c00" }}>
            📄 Document Upload
          </h3>

          {/* Empty State */}
          {images.length === 0 && (
            <div className="text-center mb-3">
              <img
                src={upload}
                alt="upload"
                style={{ width: "110px", opacity: 0.85 }}
              />
              <p className="text-muted mt-2 mb-0">
                Upload your document images
              </p>
              <label className='h5 mt-2'>Upload Driving License Or Voter ID Only.</label>
            </div>
          )}

          {/* Image Grid */}
          <div className="d-flex flex-wrap justify-content-center gap-3 mt-3">
            {images.map((img, index) => (
              <div
                key={index}
                className="position-relative"
                style={{ width: "120px", height: "120px" }}
              >
                <img
                  src={img.preview}
                  alt="doc"
                  className="w-100 h-100"
                  style={{
                    objectFit: "cover",
                    borderRadius: "12px",
                    boxShadow: "0 4px 10px rgba(255, 140, 0, 0.25)",
                  }}
                />

                {/* Delete */}
                <button
                  onClick={() => removeImage(index)}
                  className="position-absolute top-0 end-0 translate-middle rounded-circle"
                  style={{
                    width: "22px",
                    height: "22px",
                    border: "none",
                    background: "#ff4d4f",
                    color: "white",
                    fontSize: "14px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  ×
                </button>
              </div>
            ))}
          </div>

          {/* Upload Button (no input shown) */}
          <label
            htmlFor={!isDocumentLimitReached ? "fileUpload" : ""}
            className="mt-4 text-center"
            style={{
              display: "block",
              padding: "12px",
              borderRadius: "10px",
              background: isDocumentLimitReached
                ? "#ccc"
                : "linear-gradient(135deg, #ff8c00, #ffa94d)",

              cursor: isDocumentLimitReached
                ? "not-allowed"
                : "pointer",

              pointerEvents: isDocumentLimitReached
                ? "none"
                : "auto",
              color: "white",
              fontWeight: "500",
              boxShadow: "0 5px 15px rgba(255, 140, 0, 0.3)",
            }}
          >
            + Add Document Images
          </label>

          <input
            id="fileUpload"
            type="file"
            multiple
            accept="image/*"
            onChange={handleImageChange}
             disabled={isDocumentLimitReached}
            style={{ display: "none" }}
          />

          {/* Upload Button */}
          <button
            className="mt-3 fw-semibold"
            onClick={handleUpload}
            disabled={isDocumentLimitReached}
            style={{
             background: isDocumentLimitReached ? "#ccc" : "#ff8c00",
              color: "white",
              border: "none",
              borderRadius: "10px",
              padding: "10px",
              width: "100%",
              boxShadow: "0 5px 15px rgba(255, 140, 0, 0.35)",
              cursor: isDocumentLimitReached ? "not-allowed" : "pointer",
            }}
          >
            Upload
          </button>
          <button
            className="btn w-100 mt-4 fw-semibold"
            onClick={clickEditPage}
            style={{
              backgroundColor: "#2b90e2",
              color: "white",
              boxShadow: "0 4px 12px rgba(40, 127, 185, 0.4)",
              border: "none",
            }}
          >
            Close
          </button>
        </div>

        <div className="w-50  p-3 d-flex flex-wrap gap-2 mt-4" style={{
          maxHeight: "400px",
          overflowY: "auto",


        }}>
          {documentList.map((img, index) => (
            <div
              key={index}
              className="position-relative"
              style={{ width: "200px", height: "200px" }}
            >
              <img
                src={img.documentPath}
                alt="preview"
                className="img-thumbnail w-100 h-100"
                style={{
                  objectFit: "cover",
                  borderRadius: "10px",
                  boxShadow: "0 4px 10px rgba(255, 140, 0, 0.25)",
                }}
              />

              <button
                onClick={() => documentDeleteAPICall(loginVal.user_Id, img.id)}
                className="btn btn-danger btn-sm position-absolute top-0 end-0   rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "25px", height: "25px", padding: 0 }}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DocumentUpload;
